<template>
    <div class="modal fade" :id="'updateAdmittedModal' + _uid" role="dialog" aria-labelledby="updateAdmittedModalLabel" backdrop="static" data-backdrop="static" aria-hidden="true">
        <div class="modal-dialog modal-xl" role="document">
            <div class="modal-content">
                <div class="modal-header mt-0 mb-0">
                    <h5 class="modal-title" id="updateAdmittedModalLabel">{{ model.modalTitle }}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body p-0">
                    <admitted-edit-card v-model="model"
                                            @save="onSave"
                                            @cancel="onCancel"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { AdmittedMultipleUpdateModel } from '@/models/models';
    import AdmittedEditCard from './AdmittedEditCard';

    export default {
        components: {
            AdmittedEditCard
        },
        props: {
            value: {
                type: Object,
                required: false
            },
            show: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                model: new AdmittedMultipleUpdateModel(),
            };
        },
        methods: {
            onClose(e, fromBtn) {
                if ((e && e.target.id === `updateAdmittedModal${this._uid}`) || fromBtn === true) {
                    this.$emit('onClose', { ...this.model });
                    this.model = new AdmittedMultipleUpdateModel();
                } else {
                    $(this.$el).focus();
                }
            },
            hide(e) {
                $('#updateAdmittedModal' + this._uid).modal('hide');
            },
            onSave(model) {
                this.$emit('onSave', model);
                this.onClose(null, true);
            },
            onCancel() {
                this.onClose(null, true);
            }
        },
        mounted() {
            // add modal close listener
            $('#updateAdmittedModal' + this._uid).on('hidden.bs.modal', this.onClose);
        },
        beforeDestroy() {
            // remove listener
            $('#updateAdmittedModal' + this._uid).off('hidden.bs.modal');
        },
        watch: {
            show: function (val) {
                if (val) {
                    this.model = new AdmittedMultipleUpdateModel(this.value);

                    $('#updateAdmittedModal' + this._uid).modal('show');
                } else {
                    $('#updateAdmittedModal' + this._uid).modal('hide');
                }
            }
        }
    };
</script>
